var shopifyRoutesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

function cartRoute(path) {
    return shopifyRoutesRoot + path.replace(/^\/+/, '');
}

function localizedItemUrl(url) {
    if (!url) return '#';

    if (/^https?:\/\//i.test(url)) {
        return url;
    }

    if (shopifyRoutesRoot !== '/' && url.indexOf(shopifyRoutesRoot) === 0) {
        return url;
    }

    return shopifyRoutesRoot + url.replace(/^\/+/, '');
}

function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, function(character) {
        return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        }[character];
    });
}

function getCart() {
    fetch(cartRoute('cart.js'))
        .then((resp) => resp.json())
        .then((data) => {

            var upsellContainer = document.querySelector('.drawer_cart_upsell.product-slider__upsell');

            if(data.items.length > 0) {

                if (upsellContainer) {
                    upsellContainer.classList.remove('hidden');
                }


                //CART NOT EMPTY
                var cartItemsWrapper = document.getElementById('drawer_cart_items');
                var cartItems = '';
                data.items.forEach(function(product, index) {
                    var itemUrl = localizedItemUrl(product.url);
                    var itemTitle = escapeHtml(product.title);
                    var itemImageAlt = product.featured_image && product.featured_image.alt ? escapeHtml(product.featured_image.alt) : itemTitle;

                    cartItems +=
                        '<div class="drawer_cart_item" data-pid="' + product.id + '">' +
                        '<a href="' + itemUrl + '" class="drawer_cart_item_image">' +
                        '<img src="' + product.featured_image.url + '" alt="' + itemImageAlt + '">' +
                        '</a>' +
                        '<div class="cart__line-item--description">' +
                        '<div class="drawer_cart_item_text">' +
                        '<a href="' + itemUrl + '" class="title">' + itemTitle +
                        '</a>' +
                        '</div>' +
                        '<p class="drawer_cart_item_price" data-ppriceid="' + product.id + '">' + Shopify.formatMoney(product.quantity * product.price) + '</p>' +
                        '<div class="drawer_cart_item_controls">' +
                        '<div class="cart__line-item--qty">' +
                        '<div class="NumberStepper" data-pprice="' + Shopify.formatMoney(product.price) + '">' +
                        '<button class="NumberStepper__button NumberStepper__button--step-down" data-id="' + product.id + '" data-name="' + itemTitle + '" data-pid="' + product.product_id + '" data-sku="' + product.sku + '">Decrement</button>' +
                        '<input type="number" value="' + product.quantity + '" class="NumberStepper__qty" readonly="true" disabled="true" aria-label="Quantity" data-idqt="' + product.id + '">' +
                        '<button class="NumberStepper__button NumberStepper__button--step-up" data-id="' + product.id + '" data-name="' + itemTitle + '" data-pid="' + product.product_id + '" data-sku="' + product.sku + '">Increment</button>' +
                        '</div>' +
                        '</div>' +
                        '<button type="button" class="cart__line-item--remove button button--link" data-id="' + product.id + '"> Remove </button>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                });
                cartItemsWrapper.innerHTML = cartItems;
                document.getElementById('drawer_checkout_btn').classList.remove('disabled');
                document.getElementById('drawer_checkout_btn').removeAttribute('disabled');
                document.getElementById('drawer_checkout_btn').style.pointerEvents = 'auto';

                
            } else {
                //CART EMPTY

                if (upsellContainer) {
                    upsellContainer.classList.add('hidden');
                }
                emptyCartData();
            }

            document.getElementById('drawer-cart').style.margin = '0';
            document.getElementById('drawer_total_amount').innerHTML = Shopify.formatMoney(data.total_price);

            deleteItem();
            decrementItem();
            incrementItem();

            document.querySelectorAll('.navigation__item--cart-count').forEach( element => {
                element.innerHTML = data.item_count;
            });
        });
};

function emptyCartData() {
    document.getElementById('drawer_cart_items').innerHTML = '<div class="cart-empty-state"><svg class="cart-empty-svg" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.393 10.066a.37.37 0 00-.245-.101H8.059a.377.377 0 00-.266.63l4.95 4.952H9.127a.377.377 0 00-.368.37v2.18c.004.205.17.37.376.37l3.606.003-4.954 4.954a.368.368 0 00-.095.247c0 .206.165.373.373.376h3.072a.376.376 0 00.274-.117l4.81-4.81a.364.364 0 00.105-.246v-3.73a.37.37 0 00-.121-.266l-4.813-4.812zm5.613 23.547C7.851 33.613.4 26.163.4 17.005.4 7.85 7.85.4 17.007.4s16.606 7.449 16.606 16.605c0 9.158-7.449 16.608-16.607 16.608zm0-30.343c-7.573 0-13.735 6.162-13.735 13.735 0 7.575 6.162 13.737 13.735 13.737 7.576 0 13.737-6.162 13.737-13.737 0-7.573-6.161-13.735-13.736-13.735zm5.614 6.796a.38.38 0 01.245-.101h3.09a.377.377 0 01.367.375c0 .099-.04.188-.101.255l-4.949 4.952h3.615c.201.004.363.168.367.37v2.18a.376.376 0 01-.376.37l-3.606.003 4.956 4.954a.375.375 0 01.094.247.378.378 0 01-.374.376h-3.071a.377.377 0 01-.275-.117l-4.81-4.81a.371.371 0 01-.104-.246v-3.73a.37.37 0 01.121-.266l4.811-4.812z"></path></svg><p>' + window.cartStrings.emptyMessage + '</p> <a style="margin-top: -15px" href="' + window.cartStrings.continueBuyUrl + '"><button type="button" class="button button--link drawer_cart-continue-shopping" aria-label="Shop">' + window.cartStrings.continueBuyText + '</button> </a> </div>';
    document.getElementById('drawer_checkout_btn').setAttribute('disabled', 'disabled');
    document.getElementById('drawer_checkout_btn').classList.add('disabled');
    document.getElementById('drawer_checkout_btn').style.pointerEvents = 'none';
}

function priceToCents(price) {
  let priceStr = price.substring(1);
  priceStr = priceStr.replace(',', '');
  return priceStr;
}

function deleteItem() {
    const close_btns = document.querySelectorAll('.cart__line-item--remove');
    close_btns.forEach(btn => {
        btn.addEventListener('click', event => {
            var target = event.target;
            var data_id = target.getAttribute('data-id');
            var data_name = target.getAttribute('data-name');
            var data_pid = target.getAttribute('data-pid');
            var data_sku = target.getAttribute('data-sku');
            const data = { 'id': data_id, 'quantity': 0 };
            const dataqt = { 'id': data_id, 'quantity': 0, 'sku': data_sku, 'product_id': data_pid, 'product_name': data_name  };

            fetch(cartRoute('cart/change.js'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then(response => response.json())
                .then(data => {
                    var upsellContainer = document.querySelector('.drawer_cart_upsell.product-slider__upsell');
                    
                     // Call the function to update the upsell after deleting a product
                if (typeof window.updateUpsellItems === 'function') {
                    window.updateUpsellItems();
                }

                    if ( data.item_count == 0 ) {
                        emptyCartData();

                        if (upsellContainer) {
                            upsellContainer.classList.add('hidden');
                        }
                    } else{
                        if (upsellContainer) {
                            upsellContainer.classList.remove('hidden');
                        }
                    }

                       
                    document.getElementById('drawer_total_amount').innerHTML = Shopify.formatMoney(data.total_price);
                    document.querySelectorAll('.navigation__item--cart-count').forEach( element => {
                        element.innerHTML = data.item_count;
                    });

                    const e = document.querySelector('[data-pid="' + dataqt.id + '"]');
                    e.parentElement.removeChild(e);

                    

                    let dlEvent = {
                      'product': {
                        'id'       : dataqt.product_id,
                        'sku'      : dataqt.sku,
                        'variant'  : dataqt.id,
                      },
                      'pageType'   : "Cart",
                      'event'      : "Removed from cart"
                    };

                    dataLayer.push(dlEvent);
                })
        });
    });
};

function decrementItem() {
    const decrement_btns = document.querySelectorAll('.NumberStepper__button--step-down');
    decrement_btns.forEach(btn => {
        btn.addEventListener('click', event => {
            var target = event.target;
            var data_id = target.getAttribute('data-id');
            var data_name = target.getAttribute('data-name');
            var data_pid = target.getAttribute('data-pid');
            var data_sku = target.getAttribute('data-sku');
            var data_price = target.parentElement.getAttribute('data-pprice');
            var current_qty = btn.nextElementSibling.value;
            var new_qty = parseInt(current_qty) - 1;
            var new_price = new_qty * priceToCents(data_price);

            const data = { 'id': data_id, 'quantity': new_qty };
            const dataqt = { 'id': data_id, 'quantity': new_qty, 'price': new_price, 'sku': data_sku, 'product_id': data_pid, 'product_name': data_name };

            fetch(cartRoute('cart/change.js'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then(response => response.json())
                .then(data => {
                    document.querySelector('[data-idqt="' + dataqt.id + '"]').setAttribute('value', dataqt.quantity);
                    document.querySelector('[data-ppriceid="' + dataqt.id + '"]').innerHTML = Shopify.formatMoney(dataqt.price);
                    document.getElementById('drawer_total_amount').innerHTML = Shopify.formatMoney(data.total_price);
                    document.querySelectorAll('.navigation__item--cart-count').forEach( element => {
                        element.innerHTML = data.item_count;
                    });
                    let dlEvent = {
                      'product': {
                        'id'       : dataqt.product_id,
                        'sku'      : dataqt.sku,
                        'variant'  : dataqt.id,
                        'price'    : dataqt.price,
                        'quantity' : dataqt.quantity
                      },
                      'pageType'   : "Cart",
                      'event'      : "Decremented quantity"
                    };

                    dataLayer.push(dlEvent);
                })
        });
    });
};

function incrementItem() {
    const increment_btns = document.querySelectorAll('.NumberStepper__button--step-up');
    increment_btns.forEach(btn => {
        btn.addEventListener('click', event => {
            var target = event.target;
            var data_id = target.getAttribute('data-id');
            var data_name = target.getAttribute('data-name');
            var data_pid = target.getAttribute('data-pid');
            var data_sku = target.getAttribute('data-sku');
            var data_price = target.parentElement.getAttribute('data-pprice');
            var current_qty = btn.previousElementSibling.value;
            var new_qty = parseInt(current_qty) + 1;
            var new_price = new_qty * priceToCents(data_price);

            const data = { 'id': data_id, 'quantity': new_qty };
            const dataqt = { 'id': data_id, 'quantity': new_qty, 'price': new_price, 'sku': data_sku, 'product_id': data_pid, 'product_name': data_name };

            fetch(cartRoute('cart/change.js'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then(response => response.json())
                .then(data => {
                    document.querySelector('[data-idqt="' + dataqt.id + '"]').setAttribute('value', dataqt.quantity);
                    document.querySelector('[data-ppriceid="' + dataqt.id + '"]').innerHTML = Shopify.formatMoney(dataqt.price);
                    document.getElementById('drawer_total_amount').innerHTML = Shopify.formatMoney(data.total_price);
                    document.querySelectorAll('.navigation__item--cart-count').forEach( element => {
                        element.innerHTML = data.item_count;
                    });
                    let dlEvent = {
                      'product': {
                        'id'       : dataqt.product_id,
                        'sku'      : dataqt.sku,
                        'variant'  : dataqt.id,
                        'price'    : dataqt.price,
                        'quantity' : dataqt.quantity
                      },
                      'pageType'   : "Cart",
                      'event'      : "Incremented quantity"
                    };

                    dataLayer.push(dlEvent);
                })
        });
    });
};

window.onload = function(){
    getCart();
}

var cartDrawer = function () {
    if (!Element.prototype.closest) {
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
        Element.prototype.closest = function (s) {
            var el = this;
            var ancestor = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (ancestor.matches(s)) return ancestor;
                ancestor = ancestor.parentElement;
            } while (ancestor !== null);
            return null;
        };
    }
    var settings = {
        speedOpen: 50,
        speedClose: 350,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        selectorTarget: '[data-drawer-target]',
        selectorTrigger: '[data-drawer-trigger]',
        selectorClose: '[data-drawer-close]',
    };

    var toggleccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
            event.setAttribute('aria-expanded', false);
        } else {
            event.setAttribute('aria-expanded', true);
        }
    };

    var openDrawer = function (trigger) {
        var target = document.getElementById(trigger.getAttribute('aria-controls'));
        target.classList.add(settings.activeClass);
        document.documentElement.style.overflow = 'hidden';
        toggleccessibility(trigger);

        setTimeout(function () {
            target.classList.add(settings.visibleClass);
            slider_sidecart.reloadCells();
            slider_sidecart.resize();
            

        }, 500);

        
        
        

        window.dataLayer = window.dataLayer || [];
        let dlEvent = {
          'pageType'   : "Cart",
          'event'      : "Open cart"
        };

        dataLayer.push(dlEvent);
    };

    var closeDrawer = function (event) {
        var closestParent = event.closest(settings.selectorTarget),
            childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
        closestParent.classList.remove(settings.visibleClass);
        document.documentElement.style.overflow = '';
        toggleccessibility(childrenTrigger);
        setTimeout(function () {
            closestParent.classList.remove(settings.activeClass);
        }, settings.speedClose);

        window.dataLayer = window.dataLayer || [];
        let dlEvent = {
          'pageType'   : "Cart",
          'event'      : "Close cart"
        };

        dataLayer.push(dlEvent);
    };

    var clickHandler = function (event) {
        var toggle = event.target,
            open = toggle.closest(settings.selectorTrigger),
            close = toggle.closest(settings.selectorClose);


        if (open) { openDrawer(open); }
        if (close) { closeDrawer(close); }
        if (open || close) { event.preventDefault(); }
    };


    var keydownHandler = function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            var drawers = document.querySelectorAll(settings.selectorTarget),
                i;
            for (i = 0; i < drawers.length; ++i) {
                if (drawers[i].classList.contains(settings.activeClass)) {
                    closeDrawer(drawers[i]);
                }
            }
        }
    };

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
    let openCart = localStorage.getItem("cart");
    if (openCart == 'open') {
      openDrawer(document.querySelector('.navigation__cart a.navigation__link-wrapper'));
      localStorage.removeItem("cart");
    }

    document.querySelector('#drawer-cart').addEventListener('product:addToCart', function (e, productID, productPrice) {
      // openDrawer(document.querySelector('.navigation__cart a.navigation__link-wrapper'));
      let dlEvent = {
        'pageType'   : window.theme.currentPage,
        'event'      : 'Add to Cart',
        'productId' : e.detail.productID,
        'currency' : window.theme.currentCurrency,
        'value' : e.detail.productPrice.replace(',','.').substring(1)
      };

      dataLayer.push(dlEvent);
    },false);

    document.querySelector('#drawer-cart').addEventListener('product:added', function (e, productID, productPrice) {
        
      openDrawer(document.querySelector('.navigation__cart a.navigation__link-wrapper'));
      let dlEvent = {
        'pageType'   : window.theme.currentPage,
        'event'      : 'Product Added'
      };

      dataLayer.push(dlEvent);
    },false);
};

cartDrawer();
